/* Change this file to get your personal Portfolio */

// To change portfolio colors globally go to the  _globalColor.scss file

import emoji from "react-easy-emoji";
import splashAnimation from "./assets/lottie/splashAnimation"; // Rename to your file name for custom animation

// Splash Screen

const splashScreen = {
  enabled: true, // set false to disable splash screen
  animation: splashAnimation,
  duration: 4800 // Milliseconds — longer so users can read splash content
};

// Summary And Greeting Section

const illustration = {
  animated: true // Set to false to use static SVG
};

const greeting = {
  username: "H. M. Umair Khalid",
  title: "Umair Khalid",
  subTitle:
    "Results-driven Full-Stack Developer with 3+ years of experience building and deploying scalable web apps end to end. Skilled across Node.js, React, Next.js, Angular, Nuxt.js, and AWS — with CI/CD, payments, and third-party integrations. Delivered production systems supporting 1,500+ active users with 99.9% uptime in Agile teams.",
  resumeLink:
    "https://drive.google.com/file/d/1tV428PTKnDTCWs2Epmd9xQiLQjTstjy_/view?usp=sharing", // Set to empty to hide the button
  displayGreeting: true // Set false to hide this section, defaults to true
};

// Social Media Links

const socialMediaLinks = {
  github: "https://github.com/hafizumair74",
  linkedin: "https://www.linkedin.com/in/umair-khalid-62133422a/",
  gmail: "hafizumair74@gmail.com",
  gitlab: "",
  facebook: "",
  medium: "",
  stackoverflow: "",
  // Instagram, Twitter and Kaggle are also supported in the links!
  // To customize icons and social links, tweak src/components/SocialMedia
  display: true // Set true to display this section, defaults to false
};

// Skills Section

const skillsSection = {
  title: "Skills",
  subTitle: "TECHNOLOGIES AND TOOLS I WORK WITH",
  skills: [
    "Full-stack development with Node.js, React, Next.js, Angular, Nuxt.js, and Vue.js",
    "Building RESTful APIs with Express.js — authentication, authorization, validation middleware, and business logic",
    "Database design and optimization with PostgreSQL (Sequelize ORM) and MongoDB",
    "Cloud & DevOps on AWS (Lambda, SQS, SNS, ECS, ECR, EC2, S3, CloudFormation) plus DigitalOcean / CloudPanel",
    "CI/CD with AWS CodePipeline, CodeBuild, CodeDeploy, GitHub Actions, and Jenkins",
    "Integrations: Socket.IO / WebSockets, Stripe payments, SendGrid email, and MinIO object storage"
  ],

  softwareSkills: [
    {
      skillName: "Node.js",
      fontAwesomeClassname: "fab fa-node-js"
    },
    {
      skillName: "React",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Next.js",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Nuxt.js",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "Vue.js",
      fontAwesomeClassname: "fab fa-vuejs"
    },
    {
      skillName: "Angular",
      fontAwesomeClassname: "fab fa-angular"
    },
    {
      skillName: "TypeScript",
      fontAwesomeClassname: "fab fa-js"
    },
    {
      skillName: "Express.js",
      fontAwesomeClassname: "fas fa-server"
    },
    {
      skillName: "PostgreSQL",
      fontAwesomeClassname: "fas fa-database"
    },
    {
      skillName: "MongoDB",
      fontAwesomeClassname: "fas fa-leaf"
    },
    {
      skillName: "AWS",
      fontAwesomeClassname: "fab fa-aws"
    },
    {
      skillName: "Docker",
      fontAwesomeClassname: "fab fa-docker"
    },
    {
      skillName: "Stripe",
      fontAwesomeClassname: "fab fa-stripe"
    },
    {
      skillName: "Git",
      fontAwesomeClassname: "fab fa-git-alt"
    },
    {
      skillName: "Socket.IO",
      fontAwesomeClassname: "fas fa-plug"
    },
    {
      skillName: "Tailwind CSS",
      fontAwesomeClassname: "fab fa-css3-alt"
    },
    {
      skillName: "Redux",
      fontAwesomeClassname: "fab fa-react"
    },
    {
      skillName: "Sass",
      fontAwesomeClassname: "fab fa-sass"
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Education Section

const educationInfo = {
  display: true, // Set false to hide this section, defaults to true
  schools: [
    {
      schoolName: "Punjab University College of Information Technology (PUCIT)",
      logo: require("./assets/images/pucit.png"),
      subHeader: "Bachelor of Science in Information Technology",
      duration: "08/2018 - 08/2022",
      desc: "Lahore, Pakistan",
      descBullets: []
    }
  ]
};

// Your top 3 proficient stacks/tech experience

const techStack = {
  viewSkillBars: true, // Set it to true to show Proficiency Section
  experience: [
    {
      Stack: "Full-Stack Development",
      progressPercentage: "92%"
    },
    {
      Stack: "Backend Development (Node.js, Express)",
      progressPercentage: "90%"
    },
    {
      Stack: "Frontend (React, Next.js, Nuxt.js, Angular)",
      progressPercentage: "88%"
    },
    {
      Stack: "DevOps & AWS / DigitalOcean",
      progressPercentage: "84%"
    },
    {
      Stack: "Integrations (Stripe, APIs, Socket.IO)",
      progressPercentage: "85%"
    },
    {
      Stack: "Database Design & Management",
      progressPercentage: "82%"
    }
  ],
  displayCodersrank: false // Set true to display CodersRank badges section; you need to change your username in src/containers/skillProgress/skillProgress.js:17:62, defaults to false
};

// Work experience section

const workExperiences = {
  display: true, // Set it to true to show the workExperiences section
  experience: [
    {
      role: "Full-Stack Developer",
      company: "Techtics.AI",
      companylogo: require("./assets/images/TechticsLogo.png"),
      date: "12/2022 - Present",
      desc: "A tech company specializing in AI solutions and development. Lahore, Pakistan",
      descBullets: [
        "Design and develop end-to-end web applications using Node.js/Express.js for backend services and React.js, Next.js, Angular/TypeScript, and Nuxt.js/Vue.js for frontend interfaces",
        "Build and maintain RESTful APIs, implementing authentication, authorization, validation middleware, and business logic",
        "Design and optimize PostgreSQL databases using Sequelize ORM, ensuring efficient queries, data integrity, and scalability",
        "Implement file upload and attachment management using MinIO (S3-compatible object storage)",
        "Develop reusable, responsive UI components and improve frontend performance",
        "Integrate real-time features using Socket.IO, plus payment and email flows with Stripe and SendGrid",
        "Collaborate with cross-functional teams in an Agile environment, conduct code reviews, and follow best practices",
        "Contribute to architectural decisions and application scalability improvements"
      ]
    },
    {
      role: "DevOps Engineer",
      company: "Techtics.AI",
      companylogo: require("./assets/images/TechticsLogo.png"),
      date: "01/2024 - 09/2024",
      desc: "A tech company specializing in AI solutions and development. Lahore, Pakistan",
      descBullets: [
        "Managed cloud infrastructure and deployments using AWS services and DigitalOcean / CloudPanel",
        "Designed and maintained CI/CD pipelines using AWS CodePipeline, CodeBuild, CodeDeploy, GitHub Actions, and Jenkins",
        "Implemented Infrastructure as Code (IaC) using AWS CloudFormation",
        "Built and supported serverless and event-driven architectures using AWS Lambda, SQS, and SNS",
        "Worked with ECS, ECR, EC2, IAM, S3, App Runner, and SageMaker to support application deployment",
        "Monitored system performance, troubleshot issues, and ensured high availability and reliability (99.9% uptime)"
      ]
    }
  ]
};

/* Your Open Source Section to View Your Github Pinned Projects
To know how to get github key look at readme.md */

const openSource = {
  showGithubProfile: "false", // Set true or false to show Contact profile using Github, defaults to true
  display: true // Set false to hide this section, defaults to true
};

// Some big projects you have worked on

const bigProjects = {
  title: "Projects",
  subtitle: "Production work across full-stack, real-time, and cloud-backed products.",
  projects: [
    {
      image: require("./assets/images/McDoni-3 1.png"),
      projectName: "Ordina-Qui",
      projectDesc:
        "Self-service restaurant kiosk platform. Built full-stack with Next.js, Node/Express, Socket.IO, and PostgreSQL to streamline ordering for customers and staff.",
      tags: ["Next.js", "Node.js", "Socket.IO", "PostgreSQL"],
      videoDriveId: "1XDUEcBEt1iVIzEgyFTAtGMRI04zeLcDF",
      videoPoster: "/videos/ordinaqui-poster.jpg",
      footerLink: [
        {
          name: "Visit Website",
          url: "https://ordina.techtics.ai/"
        }
      ]
    },
    {
      image: require("./assets/images/Layer 1.png"),
      projectName: "Neonistic",
      projectDesc:
        "E-commerce for custom neon signs with live product customization. Next.js + Tailwind storefront, Node/MongoDB backend, and Socket.IO for real-time interactions.",
      tags: ["Next.js", "MongoDB", "Socket.IO", "Tailwind"],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://neonistic.com/"
        }
      ]
    },
    {
      image: require("./assets/images/globalink-network.png"),
      projectName: "Globalink Network / Global Value Network",
      projectDesc:
        "Shared Nuxt.js frontend for two products serving 1,500+ active users. Took UI from Figma to production with Tailwind/Nuxt UI at 99.9% uptime.",
      tags: ["Nuxt.js", "Tailwind CSS", "Nuxt UI", "Sass"],
      footerLink: []
    },
    {
      image: require("./assets/images/globalink-meeting.png"),
      projectName: "Globalink Meeting Site",
      projectDesc:
        "Conference platform for 300+ users — schedules, 1:1 booking, Stripe payments, and SendGrid email. 250+ registrations with 99.9% uptime on DigitalOcean.",
      tags: ["Nuxt.js", "Vue Bootstrap", "Stripe", "SendGrid", "DigitalOcean"],
      footerLink: []
    },
    {
      image: require("./assets/images/logo_rekss_no_subtext_large_rekss.png"),
      projectName: "Rekss (Engineering Management System)",
      projectDesc:
        "Internal engineering tool for Projects, Events, DFMEA/PFMEA, and interface analysis. Complex Angular/TypeScript UIs with Node/PostgreSQL services. Internal / demo.",
      tags: ["Angular", "TypeScript", "Node.js", "PostgreSQL"],
      videoDriveId: "18EEoWStjwIkoR3d_vgSY80OJO4a9EFWN",
      videoPoster: "/videos/rekss-poster.jpg",
      footerLink: []
    },
    {
      image: require("./assets/images/Layer_1.png"),
      projectName: "Muntazim",
      projectDesc:
        "Wedding event planning frontend for scheduling and coordination. Scalable React + Ant Design + Tailwind UI integrated with backend APIs.",
      tags: ["React", "Ant Design", "Tailwind"],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://muntazim.techtics.ai/"
        }
      ]
    },
    {
      image: require("./assets/images/simplaai_logo.jpeg"),
      projectName: "Simpla",
      projectDesc:
        "UAE tax calculation web app with a clean React + Bootstrap UI, reusable components, and REST API-driven flows.",
      tags: ["React", "Bootstrap", "REST APIs"],
      footerLink: [
        {
          name: "Visit Website",
          url: "https://sbx.simpla.ai/"
        }
      ]
    }
  ],
  display: true // Set false to hide this section, defaults to true
};

// Resume Section
const resumeSection = {
  title: "Resume",
  subtitle: "Feel free to download my resume",
  display: true
};

const contactInfo = {
  title: emoji("Contact Me ☎️"),
  subtitle:
    "Discuss a project or just want to say hi? My Inbox is open for all.",
  number: "0321-4058869",
  email_address: "hafizumair74@gmail.com",
  address: "Lahore, Pakistan"
};

const isHireable = true;

export {
  illustration,
  greeting,
  socialMediaLinks,
  splashScreen,
  skillsSection,
  educationInfo,
  techStack,
  workExperiences,
  openSource,
  bigProjects,
  contactInfo,
  isHireable,
  resumeSection
};
